module.exports = __webpack_public_path__ + "img/電気回路_4_4_1.6e7bbfe4.png";